import { Decorative } from "@faire/design-tokens";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import classNames from "classnames";
import React from "react";

import { SDUIBannerTextContent } from "@faire/retailer/components/SDUI/ComponentRenderers/Banner/__internal__/BannerTextContent/SDUIBannerTextContent";
import { BannerImages } from "@faire/retailer/components/SDUI/ComponentRenderers/Banner/__internal__/ImageTextBanner/__internal__/BannerImages";

import {
  ImageTextBannerProps,
  ImageTextBannerVariant,
} from "./__internal__/types";
import {
  imageTextBannerTextContent,
  imageTextBannerWrapper,
  imageTextBannerWrapperLeftVariant,
  imageTextBannerWrapperRightVariant,
} from "./styles/SDUIImageTextBannerRenderer.css";

type ExternalFacingImageTextBannerType = Omit<ImageTextBannerProps, "variant">;
export const SDUIDefaultImageTextBannerRenderer = (
  props: ExternalFacingImageTextBannerType
) => {
  return <BaseSDUIImageTextBannerRenderer {...props} variant="left" />;
};

export const SDUIImageTextBannerRenderer = (
  props: ExternalFacingImageTextBannerType
) => {
  return <BaseSDUIImageTextBannerRenderer {...props} variant="right" />;
};

const BaseSDUIImageTextBannerRenderer = ({
  bannerComponent,
  loggingData,
  variant,
  renderBehaviour,
}: ImageTextBannerProps) => {
  const { images, responsive_images, style } = bannerComponent;

  return (
    <div
      className={classNames(
        imageTextBannerWrapper,
        getWrapperVariantClass(variant)
      )}
      style={{
        backgroundColor: getSlateColorToken(
          style?.background_color,
          Decorative.tint.neutral
        ),
      }}
      data-test-id="image-text-banner-renderer"
    >
      <BannerImages
        variant={variant}
        images={images}
        responsiveImages={responsive_images}
        renderBehaviour={renderBehaviour}
      />
      <SDUIBannerTextContent
        className={imageTextBannerTextContent}
        bannerComponent={bannerComponent}
        loggingData={loggingData}
      />
    </div>
  );
};

const getWrapperVariantClass = (variant: ImageTextBannerVariant) => {
  switch (variant) {
    case "left":
      return imageTextBannerWrapperLeftVariant;
    case "right":
    default:
      return imageTextBannerWrapperRightVariant;
  }
};
